<div class="label-count-legend">
    <div
        class="label-count-legend__title"
        *ngIf="title"
    >
        {{ title }}
    </div>

    <div
        *ngFor="let row of labelList; trackBy: trackByIndex"
        class="label-count-legend__row"
    >
        <label-count-row [labelRowData]="row"></label-count-row>
    </div>

    <hr *ngIf="summarySectionLabel">
    <label-count-row
        *ngIf="summarySectionLabel"
        [labelRowData]="summarySectionLabel"
        class="label-count-legend__row"
    ></label-count-row>

    <div
        class="label-count-legend__alert"
        *ngFor="let alertMessage of alertMessages; trackBy: trackByIndex"
    >
        <avi-alert-group alertType="warning">
            <div class="label-count-legend__alert-header">
                <span>{{ alertMessage.label }}</span>
                <span *ngIf="alertMessage.count as count">{{ count }}</span>
            </div>
            <div class="label-count-legend__alert-description">{{ alertMessage.description }}</div>
        </avi-alert-group>
    </div>
</div>
